import React, { useState } from 'react'
import { Col, Container, Row } from 'react-grid-system'
import { useForm } from 'react-hook-form'
import { TailSpin } from 'react-loader-spinner'

import Checkbox from '../../../../shared/components/Checkbox/Checkbox'
import Input from '../../../../shared/components/Input/Input'
import SuccessModal from '../../../../shared/components/SuccessModal/SuccessModal'
import { submitToZoho } from '../../../../utils/api'
import styles from './styles.module.scss'

const HPForm = ({
  serviceOfInterest = '',
  afterSubmit,
}: {
  serviceOfInterest?: string
  afterSubmit?: () => void
}) => {
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [isLoad, setIsLoad] = useState(false)

  const {
    register,
    formState: { errors },
    handleSubmit,
    getValues,
    reset,
    setValue,
  } = useForm()

  const onSubmit = async () => {
    setIsLoad(true)
    const first = getValues('firstName')
    const last = getValues('lastName')
    const email = getValues('mail')
    const phone = getValues('phone')
    const orgName = getValues('org')
    const howToHelp = getValues('how_to_help')
    const service = getValues('service')

    const description = [howToHelp, service ? `Service of Interest: ${service}` : '']
      .filter(Boolean)
      .join('\n')

    try {
      await submitToZoho({
        company: orgName,
        firstName: first,
        lastName: last,
        ...(email ? { email } : {}),
        ...(phone ? { phone } : {}),
        ...(description ? { description } : {}),
      })
      reset()
      setIsModalOpen(true)
      afterSubmit?.()
    } finally {
      setIsLoad(false)
    }
  }

  return (
    <div className={styles.wrapper}>
      <Container
        style={{
          maxWidth: 1200,
        }}
      >
        <Row>
          <Col lg={6} className={styles.form_image_container}>
            <img
              className={styles.form_image}
              src={require('../../../../../public/images/contact_form.jpg')}
            />
          </Col>
          <Col lg={6} className={styles.rightContainer}>
            <Container>
              <Row>
                <Col xs={12}>
                  <div className={styles.form_content}>
                    <h3>Contact our team today</h3>
                    <p>
                      Want to talk about background checks or brainstorm about Due Diligence
                      investigation requirements?
                    </p>
                    <br />
                    <p>
                      We will put you directly in touch with a professional who will help guide you
                      to the answers you need.
                    </p>
                  </div>
                </Col>
              </Row>
            </Container>

            <form
              onSubmit={(e) => {
                e.preventDefault()
                void handleSubmit(onSubmit)()
              }}
            >
              <Container>
                <Row>
                  <Col sm={6}>
                    <Input
                      name="firstName"
                      register={register}
                      rest={{
                        disabled: isLoad,
                        style: {
                          border: errors.firstName ? '1.5px solid #ff000073' : '1px solid #E3D0C9',
                          background: errors.firstName ? '#f2dbdbf0' : '#ffff',
                        },
                        placeholder: 'First Name',
                      }}
                    />
                  </Col>
                  <Col sm={6}>
                    <Input
                      register={register}
                      name="lastName"
                      rest={{
                        disabled: isLoad,
                        style: {
                          border: errors.lastName ? '1.5px solid #ff000073' : '1px solid #E3D0C9',
                          background: errors.lastName ? '#f2dbdbf0' : '#ffff',
                        },
                        placeholder: 'Last name',
                      }}
                    />
                  </Col>
                  <Col sm={6}>
                    <Input
                      register={register}
                      pattern={{
                        value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                        message: 'invalid email address',
                      }}
                      name="mail"
                      rest={{
                        disabled: isLoad,
                        style: {
                          border: errors.mail ? '1.5px solid #ff000073' : '1px solid #E3D0C9',
                          background: errors.mail ? '#f2dbdbf0' : '#ffff',
                        },
                        placeholder: 'Company Email',
                      }}
                    />
                  </Col>
                  <Col sm={6}>
                    <Input
                      register={register}
                      name="phone"
                      required={false}
                      pattern={{
                        value: /^\+?[0-9\s().-]{7,}$/,
                        message: 'invalid phone',
                      }}
                      rest={{
                        disabled: isLoad,
                        placeholder: 'Business Phone (optional)',
                        style: {
                          border: errors.phone ? '1.5px solid #ff000073' : '1px solid #E3D0C9',
                          background: errors.phone ? '#f2dbdbf0' : '#ffff',
                        },
                      }}
                    />
                  </Col>
                  <Col sm={6}>
                    <Input
                      register={register}
                      name="org"
                      rest={{
                        disabled: isLoad,
                        style: {
                          border: errors.org ? '1.5px solid #ff000073' : '1px solid #E3D0C9',
                          background: errors.org ? '#f2dbdbf0' : '#ffff',
                        },
                        placeholder: 'Organisation',
                      }}
                    />
                  </Col>
                  <Col sm={6}>
                    <Input
                      register={register}
                      name="service"
                      defaultValue={serviceOfInterest}
                      isDropdown
                      dropdownItems={[
                        'Integrity Due Diligence & Background Screening',
                        'Asset Tracing',
                        'Corporate Investigations',
                        'Strategic and Geopolitical Risk Advisory',
                        'Supply Chains and Sanctions Compliance',
                      ]}
                      onChange={(val: string) => {
                        setValue('service', val)
                      }}
                      rest={{
                        disabled: isLoad,
                        style: {
                          border: errors.service ? '1.5px solid #ff000073' : '1px solid #E3D0C9',
                          background: errors.service ? '#f2dbdbf0' : '#ffff',
                        },
                        placeholder: 'Service of Interest',
                      }}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Input
                      register={register}
                      name={'how_to_help'}
                      required={false}
                      rest={{
                        disabled: isLoad,
                        style: {
                          border: errors.service ? '1.5px solid #ff000073' : '1px solid #E3D0C9',
                          background: errors.service ? '#f2dbdbf0' : '#ffff',
                        },
                        placeholder: 'How may we help you?',
                      }}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Checkbox
                      id={'chx-1'}
                      isError={!!errors.checkbox1}
                      register={register}
                      name={'checkbox1'}
                      required={false}
                      label={'Sign up for Urus Advisory Newsletter.'}
                    />
                    <br />
                    <Checkbox
                      id={'chx-2'}
                      isError={!!errors.checkbox2}
                      register={register}
                      name={'checkbox2'}
                      label={
                        <p>
                          Submitting this form confirms your agreement to Urus Advisory{' '}
                          <a href="/privacy" target="_blank">
                            Privacy Policy
                          </a>{' '}
                          and{' '}
                          <a href="/cookies" target="_blank">
                            Cookies Policy
                          </a>
                          .
                        </p>
                      }
                    />
                    <button
                      style={{
                        position: 'relative',
                      }}
                    >
                      SEND MESSAGE
                      {isLoad && (
                        <TailSpin
                          // visible={false}
                          height="25"
                          width="25"
                          color="#fff"
                          ariaLabel="line-wave-loading"
                          wrapperClass={styles.loader}
                          wrapperStyle={{}}
                        />
                      )}
                    </button>
                  </Col>
                </Row>
              </Container>
            </form>
          </Col>
        </Row>
      </Container>
      <SuccessModal isOpen={isModalOpen} handleModal={(val: boolean) => setIsModalOpen(val)} />
    </div>
  )
}

export default HPForm
